import type { FaireProductEntity } from "../../entity_types/product";

export const p_6mgc93455q: FaireProductEntity = {
  token: "p_6mgc93455q",
  type: "product",
  name: "Cactus Hand Cream - Flor de Madera (Pack of 12)",
  brandToken: "b_c3hepkjc1t",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/bf1b96cc7b730d999542bb8d72fb64a0a18f9a2a74f6427657332e6aa4be1b71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f058fd90ad870f744b63acd6f8143d38f4cdfc7c2155d595b0322a8473cf7c6a.jpeg",
    "https://cdn.faire.com/fastly/31caadc0f0e03b665dca3c1a5fec8e4e4f6181ba0d0bff2ba6d88ae694b610ac.jpeg",
    "https://cdn.faire.com/fastly/2882fc3770b7e2f30f43a52665fb41107661c244666b8e22631cd877488b2c4b.jpeg",
    "https://cdn.faire.com/fastly/06660b68fcb856dee30278e58bd6ba782c39ad09cb26305ff4c762b66168c8ca.jpeg",
    "https://cdn.faire.com/fastly/8fa24c60615606a12ebbba963500007894276e529b14c66dd3caf3d591e4eb60.jpeg",
    "https://cdn.faire.com/fastly/2aa02e5909faf8426d12431dab98da340778e4c9173382c7d64290eed2d168e3.png",
  ],
  priceDollars: 84,
  description:
    "Ships in packs of 12 exclusive for wholesale\n12 x 1.5 oz | 42 g\n\nA travel-friendly must-have. This ultra-luxurious nourishing hand cream delivers deep, daily hydration, powered by native Mexican prickly pear oil. Enriched with Vitamins E and K for anti-inflammatory benefits, our signature ingredient leaves skin hydrated, protected, and strengthened.\n\nVegan | Dermatologist Tested | Safe for Sensitive Skin\n\n\nKEY BENEFITS\n\n * Long-Lasting Hydration (72 hours)\n\n * Non-greasy\n\n * Fast-absorbing\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.140Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
